import { combineReducers } from '@reduxjs/toolkit';
import { escrowBalancesHeaderSlice } from './escrowBalancesHeaderSlice';
import { escrowFormDataSlice } from './escrowFormDataSlice';
import { getRemittanceSlice, sendRemittanceSlice } from './remittenenceSlice';
import { getEscrowStatementSlice } from './escrowStatementSlice';
import { getAchAccountsExcludingADSlice } from './achAccounts/getAchAccountsExcludingADSlice';
import { getAchAccountsSlice } from '../../accounting/slices/getAchAccountsSlice';
import { setFundedAtSlice } from './setFundedAtSlice';
import { addCDItemsSlice } from './addCDItemsSlice';
import { depositsReducer } from './deposits/depositsReducer';
import { disbursementsReducer } from './disbursements/disbursementsReducer';

export const orderEscrowStore = combineReducers({
  escrowBalancesHeaderSlice: escrowBalancesHeaderSlice.reducer,
  escrowFormDataSlice: escrowFormDataSlice.reducer,
  remittanceSlice: getRemittanceSlice.reducer,
  sendRemittanceSlice: sendRemittanceSlice.reducer,
  escrowStatement: getEscrowStatementSlice.reducer,
  achAccountsSlice: getAchAccountsSlice.reducer,
  getAchAccountsExcludingAD: getAchAccountsExcludingADSlice.reducer,
  getAchAccountsSlice: getAchAccountsSlice.reducer,
  addCDItems: addCDItemsSlice.reducer,
  setFundedAt: setFundedAtSlice.reducer,

  deposits: depositsReducer,
  disbursements: disbursementsReducer,
});
